"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ITEM_HEIGHT = 48;

var _default = function _default(theme) {
  return {
    action: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: [[0, theme.spacing(), theme.spacing()]],
      overflow: ' hidden',
      '& > *': {
        margin: [[0, theme.spacing() / 2]]
      },
      '& > *:first-child': {
        marginLeft: 0
      },
      '& > *:last-child': {
        marginRight: 0
      }
    },
    actionMiddle: {
      padding: [[0, theme.spacing()]]
    },
    actionRow: {
      paddingTop: theme.spacing(),
      flexDirection: 'column',
      '& > *': {
        margin: [[theme.spacing() / 2, 0]]
      },
      '& > *:first-child': {
        marginTop: 0
      },
      '& > *:last-child': {
        marginBottom: 0
      }
    },
    actionMenu: {
      maxHeight: ITEM_HEIGHT * 4.5,
      minWidth: 200,
      maxWidth: 270
    },
    borderTop: {
      borderTop: '4px solid transparent',
      boxShadow: '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)'
    },
    borderLeft: {
      borderLeft: '4px solid transparent',
      boxShadow: '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)'
    },
    content: {
      flexGrow: 1,
      flexBasis: 0,
      padding: theme.spacing()
    },
    contentRow: {
      justifyContent: 'center'
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      padding: [[theme.spacing(), theme.spacing(), 0]],
      backgroundColor: theme.palette.white
    },
    headerRow: {
      paddingBottom: theme.spacing()
    },
    headerMiddleAction: {
      paddingBottom: theme.spacing()
    },
    secondaryActions: {
      float: 'right',
      margin: [[-theme.spacing() / 2, -theme.spacing() / 2, -theme.spacing() / 2, theme.spacing() / 2]],
      '& button': {
        padding: theme.spacing() / 2,
        margin: 0,
        color: theme.palette.primary.icon,
        '& svg': {
          height: 20,
          width: 20
        }
      }
    },
    secondaryActionsRow: {
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing() / 2,
      margin: 0
    },
    menuItem: {},
    title: {
      flexGrow: 1,
      color: 'inherit'
    },
    root: {
      display: 'flex',
      flexDirection: 'column',
      minWidth: 200,
      borderRadius: 0,
      backgroundColor: theme.palette.white,
      boxShadow: 'none'
    },
    rootRow: {
      flexDirection: 'row'
    },
    clickable: {
      cursor: 'pointer',
      '&:hover': {
        boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)'
      }
    }
  };
};

exports.default = _default;